import { API_URL } from "env";

async function getSubcriptionsDetailId(subId: number) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/subscriptions/${subId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to fetch subscription details");
        }
        return data || null;
    }
    catch (error) {
        console.error("Error fetching subscription details:", error);
        return null;
    }
}
export default getSubcriptionsDetailId;